import React from 'react';
import cx from 'classnames';

import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';
import RadioItemList from '../RadioItemList';

import styles from './RegistrationStatusSection.module.scss';
import usePresenter from './RegistrationStatusSection.presenter';
import getProps from './RegistrationStatusSection.props';
import { RegistrationStatusSectionCombinedProps } from './types';


const RegistrationStatusSection: React.FC<RegistrationStatusSectionCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
    divider,
    radioItemList,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.registrationStatusSection;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.header, classes?.header)}>
        <Text
          className={cx(styles.text, classes?.text)}
          {...internalProps.text}
          {...text}/>
        <Divider
          className={cx(styles.divider, classes?.divider)}
          {...internalProps.divider}
          {...divider}/>
      </div>
      <RadioItemList
        className={cx(styles.radioItemList, classes?.radioItemList)}
        {...internalProps.radioItemList}
        {...radioItemList}/>
    </div>
  );
};

export default RegistrationStatusSection;

